import useImageProduct from "../../../../hooks/useImageProduct";
import {
  ProductCard as ProductCardComponent,
  MainInfo,
  ImageContainer,
  ProductInfo,
} from "./productCard.styles";

export function ProductCard({
  upc = "",
  company_id = 0,
  company_name = "",
  product_name = "",
  general_percentage = 0,
  image_url = "",
  category_id = 0,
  category_name = "",
  is_visible = false,
  retailers = [],
  checked = false,

  onCheckboxChange = () => {},
}) {
  const imageUrl = useImageProduct(image_url);

  const handleCheckboxChange = (e) => {
    onCheckboxChange({
      upc,
      company_id,
      category_id,
      retailers,
      is_visible,
      checked: e.target.checked,
    });
  };

  return (
    <ProductCardComponent
      className="product-item"
      onClick={() => {
        handleCheckboxChange({ target: { checked: !checked } });
      }}
    >
      {/* Main Info */}
      <MainInfo>
        <ImageContainer className="image-container">
          <img src={imageUrl} alt={product_name} onClick={() => {}} />

          <input
            type="checkbox"
            name={`checkbox-${upc}-${category_id}`}
            id={`checkbox-${upc}-${category_id}`}
            checked={checked}
            onChange={handleCheckboxChange}
          />
        </ImageContainer>

        <ProductInfo className="product-info">
          <div className="name">{product_name}</div>

          <div className="upc-and-percentage">
            <p>{upc}</p>

            <div className="percentage">
              <span className="icon material-symbols-outlined filled">
                local_police
              </span>
              <span>{general_percentage.toFixed(0)}%</span>
            </div>
          </div>

          <div className="category-name">
            {category_name.replaceAll("|", " > ")}
          </div>
        </ProductInfo>
      </MainInfo>

      {/* Bottom Side */}
      <div>{/* Custom Button Eye */}</div>
    </ProductCardComponent>
  );
}
